const addressTags = {
    "vecno:qqtsqwxa3q4aw968753rya4tazahmr7jyn5zu7vkncqlvk2aqlsdsah9ut65e":
        "(Development)",
    "vecno:qrhqvg5m9txyvtw52jweww5xv05mnpqp8u5cp5tgcj63fnydsp6xkjgqfadrj":
        "(Development)",
};

export default addressTags;